export const FETCH_HIGHLIGHT_ACTIONS = "FETCH_HIGHLIGHT_ACTIONS";
export const FETCH_HIGHLIGHT_ACTION = "FETCH_HIGHLIGHT_ACTION";
export const CREATE_HIGHLIGHT_ACTION = "CREATE_HIGHLIGHT_ACTION";
export const UPDATE_HIGHLIGHT_ACTION = "UPDATE_HIGHLIGHT_ACTION";
export const DELETE_HIGHLIGHT_ACTION = "DELETE_HIGHLIGHT_ACTION";

export function fetchHighlightActions(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_HIGHLIGHT_ACTIONS,
    auth: true,
    payload: {
      url: "superuser/highlight-actions",
      method: "GET",
      params
    }
  };
}

export function fetchHighlightAction(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_HIGHLIGHT_ACTION,
    auth: true,
    payload: {
      url: `superuser/highlight-actions/${id}`,
      method: "GET",
      params
    }
  };
}

export function createHighlightAction(data = {}) {
  return {
    type: CREATE_HIGHLIGHT_ACTION,
    auth: true,
    payload: {
      url: "superuser/highlight-actions",
      method: "POST",
      data
    }
  };
}

export function updateHighlightAction(id, data = {}) {
  return {
    type: UPDATE_HIGHLIGHT_ACTION,
    auth: true,
    payload: {
      url: `superuser/highlight-actions/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteHighlightAction(id, data = {}) {
  return {
    type: DELETE_HIGHLIGHT_ACTION,
    auth: true,
    payload: {
      url: `superuser/highlight-actions/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/highlightAction.js